import BasicCardContainer from "../../../Components/BonusUi/BasicCard/BasicCardContainer";

const BasicCard = () => {
  return <BasicCardContainer />;
};

export default BasicCard;
